import { Directive, ElementRef, forwardRef, HostListener, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

type onChangeType = (p: Number) => null;

@Directive({
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CurrencyDirective),
    },
  ],
  selector: '[appCurrency]',
  standalone: true
})
export class CurrencyDirective implements OnInit, ControlValueAccessor {
  constructor(private elementRef: ElementRef) {}

  public onChange: onChangeType;
  public onTouched = () => null;

  @HostListener('input')
  public onInput(): void {
    const element = this.elementRef.nativeElement;
    let { value } = element;

    value = value.replace(/[^0-9|\.|,]/g, '');

    element.value = value;
    this.onTouched();

    setTimeout(() => this.onChange(Number(value.replace(',', '.'))));
  }

  @HostListener('blur')
  public onBlur(): void {
    this.fixValue();
  }

  public ngOnInit(): void {
    setTimeout(() => this.onBlur());
  }

  public registerOnChange(callback: () => null): void {
    this.onChange = callback;
  }

  public registerOnTouched(callback: () => null): void {
    this.onTouched = callback;
  }

  public setDisabledState(): void {}

  public writeValue(value: string): void {
    const element: HTMLInputElement = this.elementRef.nativeElement;

    element.value = value;
    this.fixValue();
  }

  private fixValue(): void {
    const element: HTMLInputElement = this.elementRef.nativeElement;
    let { value } = element;

    if (value === null || value.trim() === '') {
      element.value = null;
      return;
    }

    const dotValue = value.replace(/,/g, '.');
    const lastDotIndex = dotValue.lastIndexOf('.');

    value = dotValue
      .split('')
      .filter((val, index) => val !== '.' || index === lastDotIndex)
      .join('');

    const numberValue = Number(value);

    setTimeout(() => this.onChange(numberValue));

    if (isNaN(numberValue)) {
      value = '';
    } else {
      value = numberValue.toFixed(2).replace('.', ',');
    }

    element.value = value;
    this.onTouched();
  }
}
